import { render, staticRenderFns } from "./VcitaButton.vue?vue&type=template&id=b525480c&scoped=true"
import script from "./VcitaButton.vue?vue&type=script&lang=js"
export * from "./VcitaButton.vue?vue&type=script&lang=js"
import style0 from "./VcitaButton.vue?vue&type=style&index=0&id=b525480c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b525480c",
  null
  
)

export default component.exports